import BaseDialog from "./BaseDialog";
import searchFileGif from "../assets/icons/search-file.gif";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import AppButton from "./AppButton";
import { twMerge } from "tailwind-merge";

interface FileUploadProcessingDialogProps {
    isOpen: boolean;
    description: string;
    error: string | null;
    onClose: () => void;
}

export default function FileUploadProcessingDialog({
    isOpen,
    description,
    error,
    onClose,
}: FileUploadProcessingDialogProps) {
    return (
        <BaseDialog
            isOpen={isOpen}
            onClose={error ? onClose : () => {}} // Only allow close if there's an error
            classes={{
                dialogPanel: "flex w-[800px] h-[400px]",
                title: error ? "text-red-600" : "text-blue-dark",
            }}
            hideCloseButton={!error}
        >
            <div className="flex flex-col h-full pb-9 items-center justify-center text-center text-blue-dark">
                <div className="mx-auto">
                    {error ? (
                        <ExclamationTriangleIcon className="w-20 h-20 text-red-600" />
                    ) : (
                        <img
                            src={searchFileGif}
                            alt="File scanning"
                            className="w-20 h-20"
                        />
                    )}
                </div>
                <h2 className="mt-4 text-[22px] font-bold">
                    {error
                        ? "Upload Error"
                        : "Scanning file… This may take a few seconds"}
                </h2>
                {description ? (
                    <p
                        className={twMerge(
                            "mt-3 text-[22px] font-medium",
                            error && "text-red-600"
                        )}
                    >
                        {description}
                    </p>
                ) : null}
            </div>
        </BaseDialog>
    );
}
